import React from 'react';
import DialogForm from 'mrf/view/DialogForm';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import { useDialogFormSelector } from 'mrf/redux/ReduxHelper';
import ButtonIcon from '../ButtonIcon';
import { EditIcon } from 'styles/components/Icons';

export default function ChangeEmailDialogForm(props) {
    const context = useDialogFormSelector({
        resource: `$changeEmailForm`,
    });

    return (
        <>
            <ButtonIcon
                icon={EditIcon}
                tooltip='Edit'
                onClick={context.open}
            />
            <DialogForm
                width='1/2'
                title={`Change Email`}
                method='PUT'
                context={context}
                {...props}
            >
                <Grid>
                    <Col size={12}>
                        <TextField
                            type='email'
                            label='Email'
                            field='email'
                        />
                    </Col>
                    <Col size={12}>
                        <TextField
                            type='password'
                            label='Confirm Password'
                            field='password'
                        />
                    </Col>
                </Grid>
            </DialogForm>
        </>
    );
}
